const defaultDataset = {
    "init": {
        answers: [
            {content: "寺岡製品のFAQ", nextId: "init_faq",icon:"/images/faq.png"},
            {content: "取り込んだドキュメントから回答", nextId: "init_faqdoc",icon:"/images/faqdoc.png"},
            {content: "寺岡サポートに連絡",  nextId: "init_support",icon:"/images/support.png"},
            {content: "部品注文/センドバック依頼",  nextId: "init_sendbak",icon:"/images/sendbak.png"},
            {content: "ChatGPT",  nextId: "init_chatgpt",icon:"/images/chatgpt.png"},
        ],
        question: "なんでも聞いてください。コンシェルジュが要望に応えます😊",
        mode: 'faq',
    },
    "trk_faq": {
        question: "trk_faq入力してください。",
    },
    "com_faq": {
        question: "com_faq入力してください。",
    },
    "sendback": {
        question: "sendback入力してください。",
    },
    "support": {
        question: "support入力してください。",
    },
    "chatgpt": {
        question: "chatgpt入力してください。",
    },
    "is_resolved": {
        answers: [
            {content: "はい", nextId: "resolved"},
            {content: "いいえ",  nextId: "not_resolved"}
        ],
        question: "解決しましたか？",
        mode: 'faq',
    },
    "resolved": {
        answers: [],
        question:"よかったです😊<br>またお声がけください。",
        mode: 'faq',
    },
    "not_resolved": {
        answers: [
            {content: "はい",  nextId: "init_support"},
            {content: "いいえ", nextId: "no_support"}
        ],
        question: "サポートと連絡が必要ですか？",
        mode: 'faq',
    },
    "init_support": {
        answers: [],
        question: `サポートへの連絡は僕が対応するよ😊
以下の情報を教えてください。<li>連絡先(任意)：</li><li>担当者：</li><li>症状：</li><li>その他：例）14時以降に連絡をお願いします。<br> Aさんと連絡が取りたいです。</li>`,
        mode: 'support',
    },
    "init_faq": {
        answers: [],
        question: `製品FAQや社内FAQは僕にお任せください。
なんでも聞いてください。`,
        mode: 'faq',
    },
    "init_faqdoc": {
        answers: [],
        question: `取り込んだドキュメントから回答するよ。
なんでも聞いてください。`,
        mode: 'faqdoc',
    },
    "init_sendbak": {
        answers: [],
        question: `センドバックや部品注文のことは僕にお任せ！<br>以下の情報を教えてください。<br><li>お名前(必須)：</li><li>連絡先(必須)：</li><li>機種(必須)：</li><li>台数：</li><li>その他(任意)：</li>`,
        mode: 'sendbak',
    },
    "init_chatgpt": {
        answers: [],
        question: `ChatGPTです。<br>お手伝いできることがあれば何でも質問してください。`,
        mode: 'chatgpt',
    },
    "no_support": {
        answers: [],
        question: "またいつでもお声がけください。😊",
        mode: 'faq',
    },
    "webapp": {
        answers: [
            {content: "問い合わせる", nextId: "contact"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "Webアプリ開発についてですね。コチラからお問い合わせできます。",
    },
    "automation_tool": {
        answers: [
            {content: "問い合わせる", nextId: "contact"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "自動化ツール開発についてですね。コチラからお問い合わせできます。",
    },
    "other_jobs": {
        answers: [
            {content: "問い合わせる", nextId: "contact"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "その他についてですね。コチラからお問い合わせできます。",
    },
    "community": {
        answers: [
            {content: "どんな活動をしているの？", nextId: "community_activity"},
            {content: "コミュニティに参加したい", nextId: "https://torahack.web.app/community/"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "2020年3月から学習コミュニティを始めました！🎉Webエンジニアへの転職を目指す人向けに、プログラミングを教えたりキャリアの相談に乗っています。",
    },
    "dating": {
        answers: [
            {content: "DMする", nextId: "https://twitter.com/torahack_"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "まずは一緒にランチでもいかがですか？DMしてください😘",
    },
}

export default defaultDataset